export const textureTypes = ['001', '002', '003', '004', '005', '006'] as const;

export type TextureType = typeof textureTypes[number];

export const getTexturePath = (type: TextureType): string => {
	return `/images/backgrounds/${type}.jpg`;
};
